import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChildren,
  QueryList,
  ViewChild,
} from '@angular/core';
import { debounce } from 'lodash-es';

import { TemplatesListTabFilterItemComponent } from 'app/apps/templates-list/templates-list-tab-filter-item/templates-list-tab-filter-item.component';
import { Tab } from 'app/shared/model/template-tab.model';
// eslint-disable-next-line @typescript-eslint/no-unused-vars

@Component({
  selector: 'cc-apps-list-tab-filter',
  templateUrl: './apps-list-tab-filter.component.html',
  styleUrls: ['./apps-list-tab-filter.component.scss'],
})
export class AppsListTabFilterComponent implements OnChanges {
  @Input() tabs: Tab[] = [];
  @Input() selectedTabIds: string[] = [];
  @Input() canEdit: boolean;
  @Output() onFilter: EventEmitter<any> = new EventEmitter();
  @Output() add: EventEmitter<any> = new EventEmitter();
  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() updateOrder: EventEmitter<any> = new EventEmitter();
  @ViewChild('tabWrapper') tabWrapper;
  @ViewChildren('tabItem') tabItems: QueryList<TemplatesListTabFilterItemComponent>;
  tabsNames: Record<string, boolean> = {};
  disabledAddButton = false;
  allTab: Tab;
  firstLoad = true;
  debounceUpdateOrder: () => void;

  constructor() {
    this.debounceUpdateOrder = debounce(
      () => this.updateOrder.emit(this.tabs.filter((tab) => !!tab.id)),
      2000,
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tabs) {
      if (changes.tabs) {
        this.initAllTab();
        this.generateNamesList();
      }

      const [selectedTabId] = this.selectedTabIds;
      if (selectedTabId) {
        this.allTab.selected = false;
        this.tabs.forEach((tab) => {
          tab.selected = tab.id === selectedTabId;
        });
      } else {
        this.allTab.selected = true;
        this.deselectTabs();
      }
    }
  }

  generateNamesList() {
    this.tabsNames = {};
    this.tabs.forEach(({ name }) => {
      this.tabsNames[name] = true;
    });
  }

  selectAll() {
    this.deselectTabs();
    this.allTab.selected = true;
    this.onFilter.emit([]);
  }

  selectTab(tabId) {
    this.deselectTabs();
    this.allTab.selected = false;
    this.onFilter.emit(tabId);
  }

  newTab() {
    this.disabledAddButton = true;
    this.tabs.push({
      id: null,
      name: '',
      style: 'dark-blue',
      new: true,
      sortValue: this.tabs.length,
      draggable: false,
    });
  }

  addTab(tab) {
    this.add.emit(tab);
  }

  enableAddButton() {
    this.disabledAddButton = false;
  }

  editTab(tab) {
    this.edit.emit(tab);
  }

  deleteTab(tabId) {
    this.delete.emit(tabId);
  }

  toggleDrag(tabId) {
    const tabPosition = this.tabs.findIndex((tab) => tab.id === tabId);
    this.tabs[tabPosition].draggable = !this.tabs[tabPosition].draggable;
  }

  dragDisabled(tab) {
    tab.draggable = tab.draggable === undefined ? true : tab.draggable;
    return !this.canEdit || !tab.draggable;
  }

  dragStarted() {
    this.removeNewTab();
    this.enableAddButton();
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex === event.currentIndex) {
      return;
    }
    moveItemInArray(this.tabs, event.previousIndex, event.currentIndex);

    this.tabs = this.tabs.map((tab, index) => {
      tab.sortValue = index;
      return tab;
    });

    this.debounceUpdateOrder();
  }

  removeNewTab() {
    const newTabIndex = this.tabs.findIndex((tab) => !tab.id);
    if (newTabIndex >= 0) {
      this.tabs.splice(newTabIndex, 1);
    }
  }

  private initAllTab() {
    this.allTab = {
      id: null,
      name: 'All',
      style: 'all-tab',
      sortValue: null,
      selected: false,
    };
  }

  private deselectTabs() {
    this.tabs.forEach((tab) => {
      tab.selected = false;
    });
  }
}
